import feathers from '@feathersjs/feathers';
import auth from '@feathersjs/authentication-client';
import store from './vuex/store';

const rest = require('@feathersjs/rest-client');
const axios = require('axios');

const url = __env.API_URL;
console.log(url);

const restClient = rest(url);
const feathersClient = feathers()
	.configure(restClient.axios(axios))
	.configure(
		auth({
			path: 'api/v3/authentication',
			storage: window.localStorage,

		}),
	);
feathersClient.hooks({
	error: {
		all: [
			async (res) => {
				if (res.error?.code === 403) {
					store.dispatch('showError', res.error?.data);
				}
			},
		],
	},
});

export default feathersClient;
